import React, { useEffect, useState } from 'react'
import { ERROR, GET_STUDENTS } from '../../../store/types'
import { fetchStudents } from '../../../store/actions/studentsActions'
import { debounce } from '../../../utils'
import { useDispatch, useSelector } from 'react-redux'
import CloseIcon from '../../elements/icons/CloseIcon'
import RadioGroup from '../../elements/form/RadioGroup'
import SearchField from '../../elements/SearchField'
import Loader from '../../elements/Loader'
import ApplicantTableSnippet from '../applications/ApplicantTableSnippet'
import CheckIcon from '../../elements/icons/CheckIcon'
import EmptyState from '../../elements/EmptyState'
import StudentsFilters from '../../elements/filters/StudentsFilters'
import ModalActionButton from '../../elements/ModalActionButton'
import { createStudentScholarship } from '../../../store/actions/scholarshipsActions'

const AddBeneficiariesToScholarship = ({scholarship, close}) => {
    const dispatch = useDispatch()
    const studentsSelector = useSelector(state => state.students)
    const scholarshipsSelector = useSelector(state => state.scholarships)
    const assignmentTypes = [
        // {
        //     label: 'All Active Students',
        //     value: 'ALL'
        // },
        {
            label: 'Specific Student(s)',
            value: 'SPECIFIC'
        },
        {
            label: 'A Group of Students',
            value: 'GROUP'
        },
    ]

    const [validationErrors, setValidationErrors] = useState({});
    const [assignmentPayload, setAssignmentPayload] = useState({});

    useEffect(() => {
        dispatch({
            type: GET_STUDENTS,
            payload: []
        })

        if(assignmentPayload?.assignmentType === 'SPECIFIC') {
            dispatch(fetchStudents('', 1, 10))
        }
        
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignmentPayload?.assignmentType]);

    const searchStudents = debounce((term) => {
        if(!term || term === '') {
            dispatch({
                type: GET_STUDENTS,
                payload: []
            })
        }
        dispatch(fetchStudents(`searchTerm=${term}`, 0, 0))
    })

    const filterStudents = (filters) => {
        // if(!term || term === '') setReload(reload + 1)
        dispatch(fetchStudents(filters, 0, 0))
    }

    const [selectedStudents, setSelectedStudents] = useState([]);

    const toggleStudentSelect = (student) => {
        let temp = [...selectedStudents]
        if(studentSelected(student._id)) {
            temp = temp.filter(s => s._id !== student._id)
        } else {
            temp.push(student)
        }
        setSelectedStudents(temp)
    }

    const studentSelected = (studentId) => {
        const isSelected = selectedStudents.find(student => {
            return student._id === studentId
        })

        return isSelected ? true : false 
    }

    const validateForm = () => {
        let errors = {}

        // if(sundriesRequirement.include) {
        //     if(!sundriesRequirement.dateFrom || sundriesRequirement.dateFrom === '') {
        //         errors.sundriesDateFrom = true
        //     }
        //     if(!sundriesRequirement.dateTo || sundriesRequirement.dateTo === '') {
        //         errors.sundriesDateTo = true
        //     }
        // }

        setValidationErrors(errors)

        return errors
    }

    const pushAssignments = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        const payload = {
            scholarship: scholarship._id,
            students: selectedStudents.map(student => {return student._id})
        }

        dispatch(createStudentScholarship(payload))
    }

    const resetStudentsList = () => {
        setSelectedStudents([])
        dispatch({
            type: GET_STUDENTS,
            payload: []
        })
    }

    return (
        <div className='w-full'>
            <div className={assignmentPayload.assignmentType && assignmentPayload.assignmentType !== 'ALL' && `min-h-[600px]`}>
                <div className='border-b pb-[10px] mb-[10px]'>
                    <div className='mt-4'>
                        <RadioGroup 
                            items={assignmentTypes} 
                            inline={true}
                            preSelectedIndex={''}
                            inputLabel={'Assignment Type'}
                            requiredField={true}
                            returnSelected={(value) => {
                                resetStudentsList()
                                setAssignmentPayload({...assignmentPayload, ...{assignmentType: value.value}})
                            }} 
                            hasError={validationErrors && validationErrors.type}  
                            titleField='label'
                        />
                    </div>

                    {/* <div className='my-2 w-full'>
                        <DateField
                            inputLabel="Payment Deadline" 
                            fieldId="payment-deadline" 
                            requiredField={false}
                            inputType="text" 
                            preloadValue={''}
                            hasError={validationErrors && validationErrors.startDate} 
                            returnFieldValue={(value)=>{
                                const formattedDate = new Date(value)
                                setAssignmentPayload({...assignmentPayload, ...{paymentDeadline: formattedDate}})
                            }}
                        />
                    </div> */}
                </div>

                {assignmentPayload.assignmentType === 'SPECIFIC' && 
                    <>
                        <p className='text-sm text-gray-500 mb-[10px]'>Search for one or more students and click on the check mark to add each student to the list of assignees for this invoice.</p>
                        {selectedStudents.length > 0 && 
                            <>
                                <p className='font-medium text-sm underline mb-[10px]'>Selected Students (<span className='font-space-grotesk'>{selectedStudents.length}</span>) </p>
                                <div className='flex items-start gap-x-[5px] flex-wrap'>
                                    {selectedStudents.map((student, studentIndex)=>(<div key={studentIndex} className='rounded bg-gray-100 p-[5px] mb-[5px] flex items-start justify-between gap-x-[10px]'>
                                        <div className='w-full'>
                                            <p className='text-xs'>{student.fullName}</p>
                                            <p className='text-xs text-gray-500'>{student.admissionNumber}</p>
                                        </div>
                                        <button onClick={()=>{toggleStudentSelect(student)}}>
                                            <CloseIcon className={`w-4 h-4`} />
                                        </button>
                                    </div>))}
                                </div>
                            </>
                        }
                        <div className='w-full'>
                            <SearchField 
                                placeholderText={`Search by student name or admission number`}
                                showResultsDropDown={false}
                                triggerSearch={(term)=>{searchStudents(term)}}
                                performingSearch={studentsSelector.loadingStudents}
                            />
                        </div>
                        {studentsSelector.loadingStudents ? 
                            <Loader />
                        :
                        <div className='overflow-y-scroll scrollbar-hidden max-h-[550px]'>
                            {studentsSelector?.students?.students?.length > 0 ? <div className='mt-[10px] w-full'>
                                {studentsSelector?.students?.students?.map((student, studentIndex) => (
                                    <div key={studentIndex} className='flex items-start justify-between my-[10px]'>
                                        <ApplicantTableSnippet 
                                            applicant={student} 
                                            showAdmissionNumber={true} 
                                            imageHeightClass='h-[35px]'
                                            imageWidthClass='w-[35px]'
                                        />
                                        <button onClick={()=>{toggleStudentSelect(student)}} className={`
                                            p-[2px] rounded transition duration-200 ${studentSelected(student._id) ? 
                                            'bg-gray-600 text-white hover:text-gray-300 active:bg-black' 
                                            : 
                                            'bg-gray-100 text-gray-400  active:bg-white hover:text-gray-600'}
                                        `}>
                                            {studentSelected(student._id) ? 
                                                <CloseIcon className="w-5 h-5" /> 
                                                :
                                                <CheckIcon className="w-5 h-5" />
                                            }
                                        </button>
                                    </div>
                                ))}
                            </div>
                            :
                            <div className='mt-[10px]'>
                                <EmptyState emptyStateText={`No students found matching your search`} />
                            </div>
                            }
                        </div>}
                    </>
                }

                {assignmentPayload.assignmentType === 'GROUP' && 
                    <>
                        <p className='text-sm text-gray-500 mb-[10px]'>Use the filters below to filter for the assignees of this invoice.</p>
                        <div className='w-full flex items-start justify-between my-5 p-2 rounded-md border'>
                            <div className='w-full'>
                                <StudentsFilters 
                                    applyFilters={(filters)=>{
                                        console.log('filters => ', filters)
                                        filterStudents(filters)
                                    }} 
                                    filtersToHide={['tribe', 'languages', 'parent']}
                                />
                            </div>
                        </div>
                        

                        {studentsSelector.loadingStudents ? 
                            <Loader />
                        :
                        <>
                            {studentsSelector.students?.students?.length > 0 ? 
                                <>
                                    <div className='w-full text-center mt-[20px]'>
                                        <h3 className='font-space-grotesk text-gray-700 font-[550] text-[24px]'>{studentsSelector.students?.total}</h3> 
                                        <p className='text-gray-500'>
                                        matches found for selected filters</p>
                                    </div> 
                                </>
                                :
                                <div className='mt-[20px]'>
                                    <EmptyState emptyStateText={`No students found matching your search`} />
                                </div>
                            }
                        </>
                        }

                    </>
                }
            </div>
        
            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Add Beneficiaries`}
                    buttonAction={()=>{pushAssignments()}}
                    processing={scholarshipsSelector.creatingStudentScholarship}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default AddBeneficiariesToScholarship